<div>
  <label>Anexos</label>
  <form
    #thisForm="ngForm"
    *ngIf="
      ((canUploadTransfer() && canEdit) ||
        canApproveUpload() ||
        canUploadDistributor()) &&
      keepEditable()
    "
    (ngSubmit)="submit()"
  >
    <div class="card mt-3">
      <div class="card-header text-uppercase">Dados do arquivo de upload</div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <label>Arquivo</label>
            <br />
            <input
              #thisInput
              type="file"
              name="file"
              data-cy="uploadFile"
              (change)="openFile($event)"
            />
          </div>
        </div>
        <div class="actions">
          <input
            type="button"
            value="Upload"
            data-cy="submit"
            class="btn btn-primary"
            [disabled]="!file"
            appDebounceClick
            (debounceClick)="submit()"
            [debounceTime]="200"
          />
        </div>
      </div>
    </div>
  </form>
  <div
    class="table-container"
    style="padding-top: 15px"
    *ngIf="Files.length > 0"
  >
    <table mat-table [dataSource]="Files" class="col-12">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createDate">
        <th mat-header-cell *matHeaderCellDef>Data de Criação</th>
        <td mat-cell *matCellDef="let element">
          {{ element.creationDate | date: "dd/MM/yyyy hh:mm:ss" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createUser">
        <th mat-header-cell *matHeaderCellDef>Usuário de Criação</th>
        <td mat-cell *matCellDef="let element">
          {{ element.creationUser }}
        </td>
      </ng-container>

      <ng-container matColumnDef="userType">
        <th mat-header-cell *matHeaderCellDef>Tipo de usuário</th>
        <td mat-cell *matCellDef="let element">
          {{ isExternalUserToText(element.isExternalUser) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions" sticky>
        <th mat-header-cell *matHeaderCellDef class="actions"></th>
        <td mat-cell *matCellDef="let element; let i = index" class="actions">
          <div>
            <a
              *ngIf="isValidFile(element.name)"
              (click)="openPdf(element.name)"
            >
              <fa-icon
                [icon]="faEye"
                style="color: rgb(22, 175, 43); padding-right: 10px"
              ></fa-icon>
            </a>
            <a (click)="download(element.name)">
              <fa-icon
                [icon]="faDownload"
                style="color: blue; padding-right: 10px"
              ></fa-icon>
              <!-- <i title="Download" class="fas fa-download fa-lg" style="color:blue"></i> -->
            </a>
            <th mat-header-cell *matHeaderCellDef></th>
            <a
              *ngIf="
                ((canUploadTransfer() && canEdit) || canApproveUpload()) &&
                canDeleteFile(element.id)
              "
              (click)="delete(element.id)"
            >
              <fa-icon [icon]="faTrash" style="color: red"></fa-icon>
              <!-- <i title="Remover" class="fas fa-trash fa-lg" style="color:red"></i> -->
            </a>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="ColumnsFile; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: ColumnsFile"></tr>
    </table>
  </div>
  <paginador
    *ngIf="Files.length > 0"
    [listedPages]="uploadListedPages"
    [firstItemOnPage]="uploadFirstItemOnPage"
    [lastItemOnPage]="uploadLastItemOnPage"
    [totalPages]="uploadTotalPages"
    [totalItems]="uploadTotalItems"
    [currentPage]="uploadCurrentPage"
    [itemsPerPage]="[10, 25, 50, 100, 200]"
    (onSearch)="loadFilesPaged($event[0], $event[1])"
  ></paginador>
  <div *ngIf="Files.length <= 0" class="card mt-3">
    <div class="card-header">
      Não foram encontrados anexos para esta boleta.
    </div>
  </div>
  <br />
</div>
